import { useEffect, useMemo } from 'react'
import { useSessionStore } from '@/features/session/model/sessionStore'
import { loadFeedNewsCache } from './feedNewsCache'
import { unreadCount, useNewsItemStateStore } from './newsItemStateStore'

/** Notícias do cache local ainda não lidas por quem está logado (Mais e barra lateral). */
export const useNewsUnreadCount = (): number => {
  const userId = useSessionStore((s) => s.user?.id ?? null)
  const read = useNewsItemStateStore((s) => s.read)
  const setUser = useNewsItemStateStore((s) => s.setUser)
  useEffect(() => {
    setUser(userId)
  }, [userId, setUser])
  const ids = useMemo(() => (userId ? loadFeedNewsCache(userId).map((item) => item.id) : []), [userId])
  return unreadCount(ids, read)
}
